export const gitInfo = ' (main #2a5a861 - 07112025-0937) wilmerhe***';
